import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/veda.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[13];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[12].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[12].path}`,
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[0].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[0].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-5">
            <h2 className="mb-5">
              Convivimos y participamos para cuidar nuestro entorno
            </h2>

            <p>
              Como hemos visto, cuidar el entorno en que vivimos es muy
              importante para tener una mejor calidad de vida.
            </p>
            <p>
              Los ciudadanos debemos informarnos sobre los{" "}
              <strong>problemas ambientales</strong> que afectan nuestro
              territorio y mantener un rol vigilante. Las empresas deben
              preocuparse por no afectar el medio ambiente con sus actividades.
              Y el Estado tiene que garantizar la protección de nuestro entorno.
            </p>
            <p>
              Se trata de un <strong>esfuerzo conjunto</strong> en el que todos
              debemos participar.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
        </div>
      </div>{" "}
      <GuiaDocente>
        <ul>
          <li>
            Pida que, en silencio, observen y lean la viñeta que aparece en el
            texto titulado Convivimos y participamos para cuidar nuestro
            entorno. Pregunte:
            <ul>
              <li>
                <i>
                  “¿Cuál es el problema que se plantea? (Posible respuesta: La
                  veda de perico. La veda busca proteger un recurso, en este
                  caso, marino. Tras una evaluación, se determina que el recurso
                  marino está siendo afectado y por lo tanto se necesita de un
                  tiempo determinado para que pueda reproducirse. Por eso se
                  establece la veda).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué ocurre si no se respeta la veda? (Posible respuesta: Se
                  extingue el recurso).
                </i>
              </li>
              <li>
                <i>
                  ¿Quiénes tienen que cumplir con la veda? (Posible respuesta:
                  La veda es tarea de todos. En este caso es función del Estado
                  establecer la veda; de la municipalidad, comunicar la veda y
                  velar por su cumplimiento; de los vendedores y transportistas,
                  evitar comprar el recurso a pescadores ilegales; y de los
                  ciudadanos, evitar su compra)”.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Pida que, por turnos, lean el texto del texto. Cierre la actividad
            señalando que la importancia de proteger nuestro entorno nos
            corresponde a todos los ciudadanos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
